export default __webpack_public_path__ + "static/media/icon7.a38366ea.svg";